import axios from "axios";
import { apiVariable } from "./apiVariable";
import { PreTripInspectionCheck } from "../interfaces/Safety/IPreTripInspectionCheck";
import { PreTripInspectionMissedStreakDto } from "../interfaces/Safety/IPreTripInspectionMissedStreak";

export const fetchPreTripInspectionChecksByDriver = async (
  token: string | null | undefined,
  driverId: string,
  month?: number,
  year?: number
): Promise<PreTripInspectionCheck[]> => {
  const params: Record<string, number> = {};

  if (month) {
    params.month = month;
  }

  if (year) {
    params.year = year;
  }

  const { data } = await axios.get(
    `${apiVariable}/getPreTripInspectionChecksByDriver/${driverId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params,
    }
  );
  return data;
};

export const createPreTripInspectionCheck = async (
  token: string | null | undefined,
  dto: Partial<PreTripInspectionCheck>
): Promise<PreTripInspectionCheck> => {
  const { data } = await axios.post(
    `${apiVariable}/createPreTripInspectionCheck`,
    dto,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return data;
};

export const updatePreTripInspectionCheck = async (
  token: string | null | undefined,
  id: string,
  dto: Partial<PreTripInspectionCheck>
): Promise<PreTripInspectionCheck> => {
  const { data } = await axios.put(
    `${apiVariable}/updatePreTripInspectionCheck/${id}`,
    dto,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return data;
};

export const fetchMissedPreTripInspectionStreaks = async (
  token: string | null | undefined,
  minimumConsecutiveDays: number
): Promise<PreTripInspectionMissedStreakDto[]> => {
  const { data } = await axios.get(
    `${apiVariable}/preTripInspectionChecks/missed/consecutive`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        minimumConsecutiveDays,
      },
    }
  );

  return data;
};
